import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Projects.css";
import { RiRobot2Fill } from "react-icons/ri";
import { GiDeliveryDrone } from "react-icons/gi";
import { GiEarthAmerica } from "react-icons/gi";
import { GiPlantWatering } from "react-icons/gi";
import { MdBarChart } from "react-icons/md";
import { MdWaterDrop } from "react-icons/md";

import {
  MdPrecisionManufacturing,
  MdOutlineMonitor,
  MdPsychology,
} from "react-icons/md";
import { GiPathDistance, GiArtificialIntelligence } from "react-icons/gi";
import { TbMapSearch } from "react-icons/tb";
// const projects = [
//   {
//     id: 1,
//     category: "robotik",
//     status: "geliştirme",
//     title: "Akıllı Hedefli İlaçlama ve Gübreleme",
//     subtitle: "Akıllı Hedefli Uygulama Sistemi",
//     desc: "Yapay zeka ile analiz edilen bitki verilerine göre sadece hastalıklı veya ihtiyaç duyulan bölgelere otonom ilaçlama ve gübreleme uygular.",
//     tags: ["Yapay Zeka", "Bilgisayarlı Görü", "ROS2"],
//     icon: <RiRobot2Fill size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "Günlük kapasite", value: "8 ton" },
//       { label: "Çalışma süresi", value: "18 saat" },
//       { label: "Hata payı", value: "%2.1" },
//     ],
//   },
//   {
//     id: 2,
//     category: "yapayzeka",
//     // status: "pilot",
//     status: "geliştirme",

//     title: "Hastalık ve Stres Tespiti",
//     subtitle: "Yapay Zeka Destekli Verim Tahmini",
//     desc: "Görüntü işleme ve sensör verileri ile bitkilerdeki hastalık, stres ve gelişim problemlerini erken aşamada tespit eder.",
//     tags: ["Multispektral", "LIDAR", "NDVI"],
//     icon: <GiDeliveryDrone size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "Tarama alanı", value: "200 ha/gün" },
//       { label: "Uçuş süresi", value: "90 dk" },
//       { label: "Görüntü çözünürlüğü", value: "2 cm/piksel" },
//     ],
//   },
//   {
//     id: 3,
//     category: "dijitalPlatform",
//     // status: "tamamlandi",
//     status: "geliştirme",

//     title: "Dijital Haritalama ve Alan Yönetimi",
//     subtitle: "Akıllı Haritalama",
//     desc: "Bahçedeki ağaç sıralarını ve alanları dijital ortamda haritalar, operasyon planlamasını kolaylaştırır.",
//     tags: ["IoT", "LoRaWAN", "Bulut"],
//     icon: <GiEarthAmerica size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "Kapsama alanı", value: "500 ha" },
//       { label: "Veri güncelleme", value: "5 dk" },
//       { label: "Batarya ömrü", value: "5 yıl" },
//     ],
//   },
//   {
//     id: 4,
//     category: "robotik",
//     status: "geliştirme",
//     title: "Otonom Navigasyon ve Sıra Takibi",
//     subtitle: "Otonom Tarım Operasyonları",
//     desc: "RTK-GPS, LiDAR ve sensör verileri ile ağaç sıraları arasında hassas şekilde ilerler, engelleri algılar ve güvenli otonom hareket sağlar.",
//     tags: ["Lazer", "Bilgisayarlı Görü", "Mekanik"],
//     icon: <GiPlantWatering size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "Tespit doğruluğu", value: "%97" },
//       { label: "İlaç tasarrufu", value: "%80" },
//       { label: "Hız", value: "5 km/saat" },
//     ],
//   },
//   {
//     id: 5,
//     category: "dijitalPlatform",
//     // status: "pilot",
//     status: "geliştirme",

//     title: "Canlı İzleme ve Uzaktan Kontrol",
//     subtitle: "Gerçek Zamanlı Takip",
//     desc: "Robotların konumu, operasyon durumu ve saha verileri gerçek zamanlı olarak takip edilir ve uzaktan yönetilebilir.",
//     tags: ["Makine Öğrenimi", "Veri Analitiği", "API"],
//     icon: <MdBarChart size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "Tahmin doğruluğu", value: "%94" },
//       { label: "Tahmin ufku", value: "90 gün" },
//       { label: "Desteklenen ürün", value: "12 çeşit" },
//     ],
//   },
//   {
//     id: 6,
//     category: "yapayzeka",
//     status: "geliştirme",
//     title: "Karar Destek ve Aksiyon Önerisi",
//     subtitle: "Görüntü Tabanlı İzleme",
//     desc: "Analiz edilen veriler doğrultusunda hangi bitkiye ne zaman ve nasıl müdahale edilmesi gerektiğini belirler.",
//     tags: ["Hassas İlaçlama", "Drone", "Harita"],
//     icon: <MdWaterDrop size={36} style={{ color: "var(--clr-primary)" }} />,
//     metrics: [
//       { label: "İlaç tasarrufu", value: "%70" },
//       { label: "Kapsama", value: "50 ha/gün" },
//       { label: "Tank kapasitesi", value: "25 litre" },
//     ],
//   },
// ];

const projects = [
  {
    id: 1,
    category: "robotik",
    status: "geliştirme",
    title: "Akıllı Hedefli İlaçlama ve Gübreleme",
    subtitle: "Akıllı Hedefli Uygulama Sistemi",
    desc: "Yapay zeka ile analiz edilen bitki verilerine göre sadece hastalıklı veya ihtiyaç duyulan bölgelere otonom ilaçlama ve gübreleme uygular.",
    tags: ["Computer Vision", "AI Decision Engine", "Precision Spraying"],
    icon: (
      <MdPrecisionManufacturing
        size={36}
        style={{ color: "var(--clr-primary)" }}
      />
    ),
    metrics: [
      { label: "Hedefleme doğruluğu", value: "%95+" },
      { label: "İlaç tasarrufu", value: "%40’a kadar" },
      { label: "Uygulama tipi", value: "Noktasal" },
    ],
  },
  {
    id: 2,
    category: "yapayzeka",
    status: "geliştirme",
    title: "Hastalık ve Stres Tespiti",
    subtitle: "Yapay Zeka Destekli Verim Tahmini",
    desc: "Görüntü işleme ve sensör verileri ile bitkilerdeki hastalık, stres ve gelişim problemlerini erken aşamada tespit eder.",
    tags: ["Machine Learning", "Image Processing", "Predictive Analytics"],
    icon: (
      <GiArtificialIntelligence
        size={36}
        style={{ color: "var(--clr-primary)" }}
      />
    ),
    metrics: [
      { label: "Tespit doğruluğu", value: "%90+" },
      { label: "Analiz süresi", value: "Gerçek zamanlı" },
      { label: "Tahmin modeli", value: "AI destekli" },
    ],
  },
  {
    id: 3,
    category: "dijitalPlatform",
    status: "geliştirme",
    title: "Dijital Haritalama ve Alan Yönetimi",
    subtitle: "Akıllı Haritalama",
    desc: "Bahçedeki ağaç sıralarını ve alanları dijital ortamda haritalar, operasyon planlamasını kolaylaştırır.",
    tags: ["Digital Mapping", "GIS", "Field Planning"],
    icon: <TbMapSearch size={36} style={{ color: "var(--clr-primary)" }} />,
    metrics: [
      { label: "Haritalama tipi", value: "Bahçe bazlı" },
      { label: "Planlama", value: "Rota destekli" },
      { label: "Yönetim", value: "Tek panel" },
    ],
  },
  {
    id: 4,
    category: "robotik",
    status: "geliştirme",
    title: "Otonom Navigasyon ve Sıra Takibi",
    subtitle: "Otonom Tarım Operasyonları",
    desc: "RTK-GPS, LiDAR ve sensör verileri ile ağaç sıraları arasında hassas şekilde ilerler, engelleri algılar ve güvenli otonom hareket sağlar.",
    tags: ["ROS2", "RTK-GPS", "Sensor Fusion"],
    icon: <GiPathDistance size={36} style={{ color: "var(--clr-primary)" }} />,
    metrics: [
      { label: "Navigasyon tipi", value: "Otonom" },
      { label: "Maks. hız", value: "5 km/s" },
      { label: "Konumlama", value: "Hassas takip" },
    ],
  },
  {
    id: 5,
    category: "dijitalPlatform",
    status: "geliştirme",
    title: "Canlı İzleme ve Uzaktan Kontrol",
    subtitle: "Gerçek Zamanlı Takip",
    desc: "Robotların konumu, operasyon durumu ve saha verileri gerçek zamanlı olarak takip edilir ve uzaktan yönetilebilir.",
    tags: ["Telemetry", "Remote Control", "Live Monitoring"],
    icon: (
      <MdOutlineMonitor size={36} style={{ color: "var(--clr-primary)" }} />
    ),
    metrics: [
      { label: "İzleme tipi", value: "Canlı veri" },
      { label: "Kontrol", value: "Uzaktan erişim" },
      { label: "Durum takibi", value: "Anlık" },
    ],
  },
  {
    id: 6,
    category: "yapayzeka",
    status: "geliştirme",
    title: "Karar Destek ve Aksiyon Önerisi",
    subtitle: "Görüntü Tabanlı İzleme",
    desc: "Analiz edilen veriler doğrultusunda hangi bitkiye ne zaman ve nasıl müdahale edilmesi gerektiğini belirler.",
    tags: ["Decision Support", "Data Analytics", "Action Recommendation"],
    icon: <MdPsychology size={36} style={{ color: "var(--clr-primary)" }} />,
    metrics: [
      { label: "Karar modeli", value: "AI destekli" },
      { label: "Öneri tipi", value: "Bitki bazlı" },
      { label: "Müdahale", value: "Zamanlama destekli" },
    ],
  },
];
const categories = [
  { key: "hepsi", label: "Tümü" },
  { key: "robotik", label: "Robotik Platform" },
  { key: "yapayzeka", label: "Yapay Zeka ve Analiz" },
  { key: "dijitalPlatform", label: "Dijital Bahçe Platform" },
];

const statusMap = {
  tamamlandi: { label: "Tamamlandı", color: "#22c55e" },
  pilot: { label: "Pilot Aşama", color: "#f59e0b" },
  geliştirme: { label: "Geliştirme", color: "#3b82f6" },
};

export default function Projects() {
  const [activeCategory, setActiveCategory] = useState("hepsi");

  const filtered =
    activeCategory === "hepsi"
      ? projects
      : projects.filter((p) => p.category === activeCategory);

  return (
    <div className="projects-page page-enter">
      <div className="projects-hero">
        <div className="container">
          <span className="section-label">Ar-Ge</span>
          <h1
            className="section-title"
            style={{ fontSize: "clamp(32px,5vw,52px)" }}
          >
            Projelerimiz
          </h1>
          <p className="section-subtitle">
            Tarımın verimliliğini ve sürdürülebilirliğini artırmak için
            geliştirdiğimiz otonom sistemler ve yapay zeka çözümleri.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="projects-filter">
          {categories.map((c) => (
            <button
              key={c.key}
              className={
                "filter-btn" +
                (activeCategory === c.key ? " filter-btn--active" : "")
              }
              onClick={() => setActiveCategory(c.key)}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="projects-grid">
          {filtered.map((p) => {
            const st = statusMap[p.status];
            return (
              <div key={p.id} className="project-card">
                <div className="project-card__header">
                  <span className="project-card__icon">{p.icon}</span>
                  <span
                    className="project-card__status"
                    style={{ "--status-color": st.color }}
                  >
                    {st.label}
                  </span>
                </div>
                <h3 className="project-card__title">{p.title}</h3>
                <p className="project-card__subtitle">{p.subtitle}</p>
                <p className="project-card__desc">{p.desc}</p>

                {/* <div className="project-card__metrics">
                  {p.metrics.map((m, i) => (
                    <div key={i} className="project-metric">
                      <span className="project-metric__value">{m.value}</span>
                      <span className="project-metric__label">{m.label}</span>
                    </div>
                  ))}
                </div> */}

                <div className="project-card__tags">
                  {p.tags.map((t, i) => (
                    <span key={i} className="project-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="projects-cta">
          <h2>İşbirliği Yapmak İster misiniz?</h2>
          <p>
            Projelerimiz hakkında daha fazla bilgi almak veya pilot uygulama
            talebi için bize ulaşın.
          </p>
          <Link to="/contact" className="btn btn-primary">
            İletişime Geç
          </Link>
        </div>
      </div>
    </div>
  );
}
